// extracted by mini-css-extract-plugin
module.exports = {"output":"DataOutputsFieldset-styles-module--output---RqA5"};